
/**
 * @export
 * @enum {string}
 */
export enum UserResetPeriod {
    NUMBER_3 = '3',
    NUMBER_4 = '4',
    NUMBER_6 = '6',
    NUMBER_12 = '12',
    NUMBER_24 = '24'
}